import React, { useState } from "react";
import { Image, Row, Col } from "react-bootstrap";
import "./powerthepolls.style.scss";
import {
  starIconTeal,
  ptpConceptImage,
  iconCheckMarkDark,
} from "../../lib/images";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

function QuizLPPowerthePolls() {
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const scriptModuleId = "ptp-form-script-module";
    if (!document.getElementById(scriptModuleId)) {
      const scriptModule = document.createElement("script");
      scriptModule.id = scriptModuleId;
      scriptModule.type = "module";
      scriptModule.src =
        "https://unpkg.com/@ptp-us/power-the-polls-form/power-the-polls-form/power-the-polls-form.esm.js";
      document.head.appendChild(scriptModule);

      const scriptNoModule = document.createElement("script");
      scriptNoModule.id = "ptp-form-script-nomodule";
      scriptNoModule.noModule = true;
      scriptNoModule.src =
        "https://unpkg.com/@ptp-us/power-the-polls-form/power-the-polls-form/power-the-polls-form.js";
      document.head.appendChild(scriptNoModule);
    }

    const applyPlaceholders = () => {
      const form = document.querySelector("power-the-polls-form");
      if (!form) return;

      const inputs = form.querySelectorAll(
        "input:not([type='checkbox']):not([type='hidden']):not([type='submit'])"
      );
      inputs.forEach((input) => {
        if (input.name === "email") {
          input.placeholder = "email*";
        } else if (input.name === "mobile_phone") {
          input.placeholder = "phone number";
        } else if (input.name === "zip") {
          input.placeholder = "zip code*";
        } else if (input.name === "name") {
          input.placeholder = "name*";
        } else if (!input.placeholder) {
          const parentLabel = input.closest("label");
          if (parentLabel) {
            const text = parentLabel.childNodes[0]?.textContent
              ?.replace("*", "")
              ?.trim()
              ?.toLowerCase();
            if (text) input.placeholder = text;
          }
        }
      });
    };

    // Replace non-functional <stencil-route-link> elements with real <a> tags
    const PTP_BASE = "https://www.powerthepolls.org";
    const fixStencilLinks = () => {
      const form = document.querySelector("power-the-polls-form");
      if (!form) return;
      form.querySelectorAll("stencil-route-link:not([data-fixed])").forEach((el) => {
        let url = el.getAttribute("url") || el.getAttribute("href") || "#";
        // Resolve relative paths against the PTP base URL
        if (url.startsWith("/")) {
          url = PTP_BASE + url;
        }
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        a.innerHTML = el.innerHTML;
        a.style.cssText = el.style.cssText;
        // Copy any inline classes from inner <a> if present
        const innerA = el.querySelector("a");
        if (innerA) {
          a.className = innerA.className;
          let innerHref = innerA.getAttribute("href") || "";
          if (innerHref.startsWith("/")) innerHref = PTP_BASE + innerHref;
          a.href = innerHref || url;
          a.innerHTML = innerA.innerHTML;
        }
        el.parentNode.replaceChild(a, el);
      });
    };

    applyPlaceholders();
    fixStencilLinks();

    const embed = document.getElementById("power-the-polls-embed");
    let observer;
    if (embed) {
      observer = new MutationObserver(() => {
        applyPlaceholders();
        fixStencilLinks();
      });
      observer.observe(embed, { childList: true, subtree: true });
    }

    const timer = setInterval(() => {
      applyPlaceholders();
      fixStencilLinks();
    }, 500);
    const timeout = setTimeout(() => clearInterval(timer), 10000);

    // Hide sub-headline on successful form submission
    const handleSubmitCompleted = () => setIsSubmitted(true);
    const waitForForm = setInterval(() => {
      const formEl = document.querySelector("power-the-polls-form");
      if (formEl) {
        formEl.addEventListener("submitCompleted", handleSubmitCompleted);
        clearInterval(waitForForm);
      }
    }, 300);
    const waitTimeout = setTimeout(() => clearInterval(waitForForm), 10000);

    return () => {
      if (observer) observer.disconnect();
      clearInterval(timer);
      clearTimeout(timeout);
      clearInterval(waitForForm);
      clearTimeout(waitTimeout);
      const formEl = document.querySelector("power-the-polls-form");
      if (formEl) {
        formEl.removeEventListener("submitCompleted", handleSubmitCompleted);
      }
    };
  }, []);

  const { t } = useTranslation();
  return (
    <div className="ctn-quiz-lp04 ptp">
      <div className="quiz-lp-top-header">
        <Image src={starIconTeal} className="icon-star-left" alt="" />
        <div className="top-header-title">
          <p>{t("our_elections_depend")}</p>
        </div>
        <Image src={starIconTeal} className="icon-star-right" alt="" />
      </div>

      <div className="ptp-hero-section">
        <div className="ptp-headline-container">
          <h2 className="ptp-main-headline">
            {t("poll_workers_get")}{" "}
            <span className="ptp-check-item">
              <span className="ptp-checkbox-box">
                <Image src={iconCheckMarkDark} alt="✓" className="ptp-check-icon" />
              </span>
              <span className="ptp-check-label">{t("training")}</span>
            </span>{" "}
            <span className="ptp-check-item">
              <span className="ptp-checkbox-box">
                <Image src={iconCheckMarkDark} alt="✓" className="ptp-check-icon" />
              </span>
              <span className="ptp-check-label">{t("paid")}</span>
            </span>
          </h2>
          {!isSubmitted && (
            <h3 className="ptp-sub-headline">{t("help_community_ptp")}</h3>
          )}
        </div>

        <Row className="ptp-content-row">
          <Col lg={6} md={12} className="ptp-embed-col">
            <div id="power-the-polls-embed" className="ptp-embed-container">
              <power-the-polls-form partner-id="tgvg"></power-the-polls-form>
            </div>
          </Col>
          <Col lg={6} md={12} className="ptp-visual-col">
            <div className="ptp-visual-container">
              <Image
                src={ptpConceptImage}
                alt="Power the Polls"
                className="ptp-concept-image"
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
export default QuizLPPowerthePolls;
